import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import { useState } from 'react';

import { SingleIconButton } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { EncuestaPreagendaType } from '@/shared/interfaces';
import EncuestaFieldsComponent from './EncuestaFieldsComponent';

export type EncuestaPreagendaCellProps = {
  encuesta: EncuestaPreagendaType;
};

const EncuestaPreagendaCell: React.FC<EncuestaPreagendaCellProps> = ({
  encuesta,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      {/* ---------- Buttons ---------- */}
      <SingleIconButton
        startIcon={<FeaturedPlayListIcon />}
        color={'default' as any}
        label={'Ver Secuenciales'}
        onClick={() => {
          setIsOpenModal(true);
        }}
      />

      {/* ---------- Modals ---------- */}
      <ScrollableDialogProps
        open={isOpenModal}
        title="Detalle de Encuesta"
        minWidth="54%"
        minHeight="30vh"
        contentNode={<EncuestaFieldsComponent encuesta={encuesta} />}
        onClose={() => setIsOpenModal(false)}
        cancelBtnColor="primary"
        cancelTextBtn="Cerrar"
      />
    </>
  );
};

export default EncuestaPreagendaCell;
